import { render, staticRenderFns } from "./NestedTable.vue?vue&type=template&id=52dcf30a&scoped=true"
import script from "./NestedTable.vue?vue&type=script&lang=js"
export * from "./NestedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcf30a",
  null
  
)

export default component.exports